import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";
import {
  Card,
  CardContent,
  Typography,
  Box,
  IconButton,
  Stack,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import {
  Close as CloseIcon,
  Add as AddIcon,
} from "@mui/icons-material";
import { getBasicPath } from "../../../../helpers";
import { useIsMobile } from "../../../../hooks/state-checkers/use-is-mobile";
import { useGetCourseFromUrl } from "../../../../hooks/use-get-course-from-url";

export default function SearchCourse({
  courseData,
  course,
  makeGroupVisibleInCourses,
  visibleCourses,
  setVisibleCourses,
  selectedUniversity,
  closeCourseNav,
}) {
  const [selected, setSelected] = useState(false);
  const location = useLocation();
  const courseIdFromPath = useGetCourseFromUrl();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  useEffect(() => {
    if (
      visibleCourses &&
      visibleCourses.length > 0 &&
      visibleCourses.find((c) => c._id === course._id)
    )
      setSelected(true);
    else setSelected(false);
  }, [visibleCourses, selectedUniversity, courseData]);

  const handleVisibleCourses = () =>
    setVisibleCourses((prev) => {
      let index = null;
      //remove
      if (
        prev.find((c, i) => {
          index = i;
          return c._id === course._id;
        })
      ) {
        if (index !== 0)
          return [...prev.slice(0, index), ...prev.slice(index + 1)];
        else return [...prev];
      }
      //add
      else return [...prev, { _id: course._id, title: course.title }];
    });

  if (!makeGroupVisibleInCourses) {
    return (
      <Card
        key={"course_wrapper" + course._id}
        sx={{
          cursor: 'pointer',
          transition: 'all 0.2s ease-in-out',
          backgroundColor: courseIdFromPath === course._id ? 'action.selected' : 'background.paper',
          border: courseIdFromPath === course._id ? '2px solid' : '1px solid',
          borderColor: courseIdFromPath === course._id ? 'primary.main' : 'divider',
          '&:hover': {
            backgroundColor: courseIdFromPath === course._id ? 'action.selected' : 'action.hover',
            transform: 'translateY(-1px)',
            boxShadow: 2,
          }
        }}
      >
        <CardContent sx={{ p: 2, '&:last-child': { pb: 2 } }}>
          <Link
            to={`/courses/${course._id}/${getBasicPath(location.pathname)}${isMobile ? "" : "?coursesearchopen=1"}`}
            style={{ 
              textDecoration: 'none', 
              color: 'inherit',
              display: 'block',
              width: '100%'
            }}
            onClick={() => {
              if (isMobile) {
                closeCourseNav();
              }
            }}
          >
            <Typography 
              variant="body1" 
              fontWeight={500}
              sx={{
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                color: 'text.primary'
              }}
            >
              {course.title}
            </Typography>
          </Link>
        </CardContent>
      </Card>
    );
  } else {
    return (
      <Card
        key={"course_wrapper" + course._id}
        sx={{
          cursor: 'pointer',
          transition: 'all 0.2s ease-in-out',
          backgroundColor: selected ? 'action.selected' : 'background.paper',
          border: selected ? '2px solid' : '1px solid',
          borderColor: selected ? 'primary.main' : 'divider',
          '&:hover': {
            backgroundColor: selected ? 'action.selected' : 'action.hover',
            transform: 'translateY(-1px)',
            boxShadow: 2,
          }
        }}
        onClick={handleVisibleCourses}
      >
        <CardContent sx={{ p: 2, '&:last-child': { pb: 2 } }}>
          <Stack direction="row" alignItems="center" justifyContent="space-between">
            <Typography 
              variant="body1" 
              fontWeight={500}
              sx={{
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                color: 'text.primary',
                flex: 1,
                mr: 1
              }}
            >
              {course.title}
            </Typography>
            {selected && course._id !== visibleCourses[0]?._id && (
              <IconButton
                size="small"
                sx={{ 
                  color: 'text.secondary',
                  '&:hover': { 
                    backgroundColor: 'action.hover',
                    color: 'error.main'
                  }
                }}
              >
                <CloseIcon fontSize="small" />
              </IconButton>
            )}
            {!selected && (
              <IconButton
                size="small"
                sx={{ 
                  color: 'text.secondary',
                  '&:hover': { 
                    backgroundColor: 'action.hover',
                    color: 'primary.main'
                  }
                }}
              >
                <AddIcon fontSize="small" />
              </IconButton>
            )}
          </Stack>
        </CardContent>
      </Card>
    );
  }
}

